import React from 'react'
import './sadguru-arpanambanner.css'

const Banner = ({ image }) => {
  return (
    <>
      <div className='container-fluid p-0' >
        <div className='saguruaprpadiv'>
          <img className='bannerimg' src={image ? image : process.env.PUBLIC_URL + '/assets/images/sadguru-arpanam/banner.png'} alt="sadguru-banner" />
        </div>
      </div>
    </>
  )
}

export default Banner